import { useGetShouldShareAllCircuits } from '@/api/user.api';
import DistributorsSettingsSection from '@/components/distributors/DistributorsSettingsSection';
import ListDistributors from '@/components/distributors/ListDistributors';
import StyledButton from '@/components/styled/StyledButton';
import StyledContainer from '@/components/styled/StyledContainer';
import StyledListHeader from '@/components/styled/StyledListHeader';
import HorizontalLine from '@/components/ui/HorizontalLine';
import PlusIcon from '@/assets/icons/plus.svg?react';
import { useState } from 'react';
import { PATHS } from '@/constants/Paths';
import { useNavigate } from 'react-router';
import { useTranslation } from '@/i18n';

const DistributorsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isSuccess } = useGetShouldShareAllCircuits();
  const [hasDistributors, setHasDistributors] = useState(false);

  return (
    <StyledContainer>
      <StyledListHeader
        title={t('distributors.title')}
        subTitle={t('distributors.subTitle')}
      >
        {isSuccess && !data.shouldShareAllCircuits && (
          <StyledButton
            title={
              hasDistributors
                ? t('distributors.addDistributors')
                : t('distributors.selectYourDistributors')
            }
            className="font-semibold gap-1 px-3 py-2"
            onClick={() => navigate(PATHS.home.distributors.add)}
            icon={<PlusIcon className="w-5 h-5 fill-white" />}
          />
        )}
      </StyledListHeader>
      <HorizontalLine />
      {isSuccess && (
        <DistributorsSettingsSection
          shouldShareAllCircuits={data.shouldShareAllCircuits}
        />
      )}
      <HorizontalLine />
      {isSuccess && !data.shouldShareAllCircuits && (
        <ListDistributors setHasDistributors={setHasDistributors} />
      )}
    </StyledContainer>
  );
};

export default DistributorsPage;
